
export const TAX_TAG_UNKNOWN = 1;
export const TAX_TAG_CONTRIBUTION = 2;
export const TAX_TAG_TRANSFER_IN = 3;
export const TAX_TAG_CONVERSION = 4;
export const TAX_TAG_ROLLOVER = 5;
export const TAX_TAG_LATE_ROLLOVER = 6;
export const TAX_TAG_POSTPONED = 7;
export const TAX_TAG_RECHARACTERIZATION = 8;
export const TAX_TAG_DISTRIBUTION = 9;
export const TAX_TAG_TRANSFER_OUT = 10;
export const TAX_TAG_CONVERSION_OUT = 11;

export const UPDATE_TAX_TAG_ERROR_TITLE = "Error updating the transaction tax tags"
export const UPDATE_TAX_TAG_ERROR_MSG = "An error occurred while updating the transaction tax tags, please try again. If this problem persists, please contact support."

export const CONTRIBUTION_YEAR_ERROR =
"Contributions must be in the transacted year or a prior year if transacted between January 1 and April 15.";
export const POSTPONED_YEAR_ERROR =
"Postponed contributions must be for a prior tax year.";
export const ROLLOVER_YEAR_ERROR =
"Rollovers must be for the same tax year as the transaction date.";
export const DISTRIBUTION_YEAR_ERROR =
"Distributions must be for the same tax year as the transaction date.";
export const CONVERSION_YEAR_ERROR =
"Conversions must be for the same tax year as the transaction date.";
export const RECHARACTERIZATION_YEAR_ERROR =
"Recharacterizations must be for a prior tax year.";
export const TAX_YEAR_NOT_APPLICABLE_ERROR =
"Tax year is not applicable for the selected event type.";
